import { BuildingType } from '../buildings';
import administrationConfig from './administration';
import apartmentConfig from './apartment';
import factoryConfig, {
    factoryHeatingConfig,
    factoryProcessesConfig,
    factoryProductionConfig,
    factorySprinklerCenterConfig,
} from './factory';
import hospitalConfig from './hospital';
import houseConfig from './house';
import industryConfig, {
    industryLabConfig,
    industryProductionConfig,
    industryTestcenterConfig,
    industryWaterConfig,
    industrySprinklerCenterConfig,
    industryHeatingCenterConfig,
} from './industry';
import ksbQuickLinksConfig from './ksb-quicklinks';
import schoolConfig from './school';
import skyscraperConfig, { skyscraperWaterUpperConfig, skyscraperWaterLowerConfig } from './skyscraper';
import hotelConfig from './hotel';
import dataCenterConfig, {
    dataCenterCoolingAirConfig,
    dataCenterCoolingDirectConfig,
    dataCenterCoolingLiquidConfig,
} from './data-center';
import ksbTeamConfig from '../building-configFr/ksb-team';
import ksbCenterConfig from '../building-configFr/ksb-center';

export const buildings = {
    [BuildingType.ADMINISTRATION]: administrationConfig,
    [BuildingType.APARTMENT]: apartmentConfig,
    [BuildingType.DATA_CENTER]: dataCenterConfig,
    [BuildingType.DATA_CENTER_COOLING_AIR]: dataCenterCoolingAirConfig,
    [BuildingType.DATA_CENTER_COOLING_DIRECT]: dataCenterCoolingDirectConfig,
    [BuildingType.DATA_CENTER_COOLING_LIQUID]: dataCenterCoolingLiquidConfig,
    [BuildingType.FACTORY]: factoryConfig,
    [BuildingType.FACTORY_HEATING]: factoryHeatingConfig,
    [BuildingType.FACTORY_PRODUCTION]: factoryProductionConfig,
    [BuildingType.FACTORY_PROCESSES]: factoryProcessesConfig,
    [BuildingType.FACTORY_SPRINKLER_CENTER]: factorySprinklerCenterConfig,
    [BuildingType.HOUSE]: houseConfig,
    [BuildingType.HOSPITAL]: hospitalConfig,
    [BuildingType.INDUSTRY]: industryConfig,
    [BuildingType.INDUSTRY_WATER]: industryWaterConfig,
    [BuildingType.INDUSTRY_TESTCENTER]: industryTestcenterConfig,
    [BuildingType.INDUSTRY_PRODUCTION]: industryProductionConfig,
    [BuildingType.INDUSTRY_LAB]: industryLabConfig,
    [BuildingType.INDUSTRY_SPRINKLER_CENTER]: industrySprinklerCenterConfig,
    [BuildingType.INDUSTRY_HEATING]: industryHeatingCenterConfig,
    [BuildingType.SCHOOL]: schoolConfig,
    [BuildingType.SKYSCRAPER]: skyscraperConfig,
    [BuildingType.SKYSCRAPER_WATER_UPPER]: skyscraperWaterUpperConfig,
    [BuildingType.SKYSCRAPER_WATER_LOWER]: skyscraperWaterLowerConfig,
    [BuildingType.KSB_QUICKLINKS]: ksbQuickLinksConfig,
    [BuildingType.KSB_TEAM]: ksbTeamConfig,
    [BuildingType.KSB_CENTER]: ksbCenterConfig,
    [BuildingType.HOTEL]: hotelConfig,
};
